import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import { AccountantYear } from "../../../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { BasicButton } from "../../../theme/Component/BasicButton";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { BankingCheckState } from "./BankingCheckState";
import { _BankingCheck, _ImportBankingCheck } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BankAccountSelect } from "../../../erp/cellEditor/BankAccount/BankAccountSelect";
import { ComponentCreditosDisponiblesDescuentoNominaTercero } from "../../../custom/forpo/components/Credit/Procesos/ComponentCreditosDisponiblesDescuentoNominaTercero";
import { FileInput } from "../../../theme/Component/FileInput";
import { DocumentStorageEditor } from "../../../contabilidad/bodegaDocumentos/DocumentStorageEditor";
import { DropDown } from "../../../theme/Component/DropDown";
import useModal, { MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { InputDate } from "../../../theme/Input/InputDate";




export const BankingCheck = () => {

    const bankingcheck = useDataBean(_BankingCheck);
    const importBanking = useDataBean(_ImportBankingCheck);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modalimp, setModalimp] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalasing, setModalasing] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [Year, setYear] = useState<any>(_single.getCurrenYear())
    const [month, setMonth] = useState<any>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [state, setstate] = useState<any>(null)
    const [idBankingAccount, setidBankingAccount] = useState<any>(null)
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [paginador.page])


    const getLista = () => {

        bankingcheck.instance.getBankingCheckReport(idBankingAccount, Year, month, state, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }

            }
        )

    }

    const importBankingCheckList = () => {
        //console.log(Project.bean);
        importBanking.instance.ImportBankingCheckList(importBanking.bean.IDBankingAccount, importBanking.bean.Media, importBanking.bean.MediaContext, null).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Lista Importada');
                setModalimp({ ...modalimp, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const setBankingCheckToDocument = () => {
        //console.log(Project.bean);
        bankingcheck.instance.setBankingCheckToDocument(bankingcheck.bean.IDBankingCheck, bankingcheck.bean.IDDocument, bankingcheck.bean.DocumentDate, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Documento Asignado al cheque');
                setModalasing({ ...modalasing, "view": false });
                getLista();
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const releaseBankingCheck = () => {
        //console.log(Project.bean);
        bankingcheck.instance.releaseBankingCheck(bankingcheck.bean.IDBankingCheck).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Cheque liberado');
                getLista();
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        bankingcheck.setBean({


        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        if (!bankingcheck.bean.IDBankingAccount) {
            toast.warning("Debe seleccionar una Cuenta Bancaria.");
            return;
        }
        if (!bankingcheck.bean.IssueDate) {
            toast.warning("Debe seleccionar una Fecha.");
            return;
        }
        if (!bankingcheck.bean.CodeNumber) {
            toast.warning("Debe proporcionar un Codigo.");
            return;
        }
        if (!bankingcheck.bean.WalletNumber) {
            toast.warning("Debe proporcionar una Chequera.");
            return;
        }
        bankingcheck.instance.updateBankingCheck(bankingcheck.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        bankingcheck.instance.deleteBankingCheck(bankingcheck.bean.IDBankingCheck).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const verimp = () => {

        setModalimp({ ...modalimp, "view": true });

    }


    const head = [
        { title: 'ID', property: 'IDBankingCheck', visible: true },
        { title: 'Código Cheque', property: 'CodeNumber', visible: true, },
        { title: 'Fecha Emisión', property: 'IssueDate', visible: true },
        { title: 'Número de Chequera', property: 'WalletNumber', visible: true },
        { title: 'Estado', property: 'UseStateName', visible: true, },
        { title: 'Tipo de Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Fecha Registro Documento', property: 'AppliedDate', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },
        { title: 'Actualiza', property: 'EmployeeName', visible: true },
        { title: 'Creado', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Asignar documento a Cheque Bancario', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalasing({ ...modalasing, "view": true }) } },
            { titulo: 'Liberar Cheque Bancario', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { releaseBankingCheck() } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar Cheque Bancario', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Cheques Bancarios">
            <div className="row">
                <div className="col-md-6">
                    <BankAccountSelect label='Cuenta Bancaria' idSelector={idBankingAccount} onChange={(e) => { setidBankingAccount(e) }} />
                </div>
                <div className="col-md-6">
                    <AccountantYear idSelector={Year} label="Año" onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-6">
                    <MonthEditorbyconst idSelector={month} onChange={(e) => { setMonth(e) }} />
                </div>
                <div className="col-md-6">
                    <BankingCheckState idSelector={state} onChange={(e) => { setstate(e) }} />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-6">
                    <BasicButton icon="ri-bar-chart-grouped-fill" clase="btn btn-outline-primary btn-border" eventClick={verimp}>
                        Importar Lista de Cheques
                    </BasicButton>
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={bankingcheck.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <BankAccountSelect label='Cuenta Bancaria' idSelector={bankingcheck.bean.IDBankingAccount} onChange={(e: any) => { bankingcheck.setBean({ ...bankingcheck.bean, 'IDBankingAccount': e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <InputDate name="bankingcheck" label="Fecha Emisión" value={bankingcheck.bean.IssueDate} setDate={(e: any) => { bankingcheck.setBean({ ...bankingcheck.bean, "IssueDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Codígo</label>
                                    <input type='text' name="CodeNumber" className="form-control" value={bankingcheck.bean.CodeNumber} onChange={bankingcheck.handleChange} />
                                </div>
                                <div className="col-md-12">
                                    <label>Chequera</label>
                                    <input type='text' name="WalletNumber" className="form-control" value={bankingcheck.bean.WalletNumber} onChange={bankingcheck.handleChange} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={bankingcheck.bean.Description} onChange={bankingcheck.handleChange} />
                                </div>
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modalimp} updateModal={setModalimp} eventModal={importBankingCheckList}>
                        <>
                            <div className="col-md-12">
                                <BankAccountSelect label='Cuenta Bancaria' idSelector={importBanking.bean.IDBankingAccount} onChange={(e: any) => { importBanking.setBean({ ...importBanking.bean, 'IDBankingAccount': e }) }} />
                            </div>
                            <div className="col-md-6">
                                <FileInput Media={importBanking.bean.Media} MediaContext={importBanking.bean.MediaContext} directory="docscheck" label="Cargar Archivo" onCreate={({ MediaContext, Media }: any) => { importBanking.setBean({ ...importBanking.bean, Media: Media, MediaContext: MediaContext }) }} />
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modalasing} updateModal={setModalasing} eventModal={setBankingCheckToDocument}>
                        <>
                            <div className="col-md-12">
                                <DocumentStorageEditor label='Documento' onChange={(e) => { bankingcheck.setBean({ ...bankingcheck.bean, "IDDocument": e.IDDocument, "DocumentDate": e.DocumentDate }) }} />
                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}